module.exports = __webpack_public_path__ + "static/media/christiaan-wauben-1.c7177c0d.jpg";